import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Spin, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../redux/selectors/commonSelectors.ts';
import { initializeSession, type CommonDispatch } from '../redux/thunks/authThunks.ts';

const { Title, Text } = Typography;

/**
 * Shell used when `VITE_AUTH_MODE=local` — the credential sign-in that replaces
 * the legacy QCDOC forms authentication and vendor portal Signin.aspx.
 *
 * On boot it revalidates any persisted token against `GET /api/Auth/me` so that
 * roles are refreshed and revoked/expired sessions are cleared.
 */
export default function LocalShell() {
  const accessToken = useSelector(selectAccessToken);
  const [checking, setChecking] = useState(!!accessToken);
  const dispatch = useDispatch<CommonDispatch>();

  useEffect(() => {
    let cancelled = false;
    void dispatch(initializeSession()).finally(() => {
      if (!cancelled) setChecking(false);
    });
    return () => { cancelled = true; };
  }, [dispatch]);

  if (checking) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          gap: 16,
        }}
      >
        <Title level={3}>QCDOC</Title>
        <Spin size="large" />
        <Text type="secondary">Restoring your session…</Text>
      </div>
    );
  }

  return <Outlet />;
}
